enum Round {
  PRIVATE = 'private',
  PUBLIC = 'public',
  COMMUNITY = 'community'
}

export default Round
